import { defineComponent, createElementBlock, openBlock, createBlock, createCommentVNode, createElementVNode, toDisplayString, mergeProps, withCtx, createTextVNode } from 'vue';
import _sfc_main$1 from './basler-components.es104.js';
/* empty css                        */
import _sfc_main$2 from './basler-components.es121.js';

const _hoisted_1 = { class: "article-teaser" };
const _hoisted_2 = { class: "article-teaser__content" };
const _hoisted_3 = {
  role: "group",
  "aria-roledescription": "Heading group"
};
const _hoisted_4 = {
  key: 0,
  class: "article-teaser__subtitle",
  "aria-roledescription": "subtitle"
};
const _hoisted_5 = { class: "article-teaser__title" };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = { class: "article-teaser__excerpt" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ArticleTeaser",
  props: {
    title: {},
    subtitle: {},
    excerpt: {},
    link: {},
    media: {},
    lazyload: { type: Boolean, default: true }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("article", _hoisted_1, [
        _ctx.media ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          media: _ctx.media,
          lazyload: _ctx.lazyload
        }, null, 8, ["media", "lazyload"])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2, [
          createElementVNode("hgroup", _hoisted_3, [
            _ctx.subtitle ? (openBlock(), createElementBlock("p", _hoisted_4, toDisplayString(_ctx.subtitle), 1)) : createCommentVNode("", true),
            createElementVNode("h2", _hoisted_5, [
              _ctx.link ? (openBlock(), createBlock(_sfc_main$2, mergeProps({ key: 0 }, _ctx.link, { class: "article-teaser__link" }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }, 16)) : (openBlock(), createElementBlock("span", _hoisted_6, toDisplayString(_ctx.title), 1))
            ])
          ]),
          createElementVNode("div", _hoisted_7, [
            createElementVNode("p", null, toDisplayString(_ctx.excerpt), 1)
          ])
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
